import { useContext } from 'react'
import { PlanGenContext } from './PlanGenContext'

export function usePlanGen() {
  const context = useContext(PlanGenContext)

  if (!context) {
    throw new Error('usePlanGen must be used within PlanGenProvider')
  }

  return context
}
